import { Navigate } from 'react-router-dom'
import PamPage from './PamPage'
import { useAuthStore } from '@/hooks'

const PamIndex = () => {
  const user = useAuthStore((state) => state.auth?.user)
  const managementUids = [
    '2f3d7a88', //lzm
    'cg5bg1b9', //lqy
    '2426ca7f', //cxn
    '3ff237cf', //wnp
    '972c2g2c', //zl
    '549g3eae', //wyy
    'g15g221e', // ry
    'g17442g3', // hhh
  ]
  const isPAMUser = managementUids.includes(user?.id)
  if (!isPAMUser) return <Navigate to="/403" />
  return <PamPage />
}

export default PamIndex
